export class ListBackupJobsRequest {
    'filters';
    'sorts';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "BackupJobsFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortBackupJobBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListBackupJobsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
